import { render } from "./SubmitChanges.vue?vue&type=template&id=ba1a212a&scoped=true"
import script from "./SubmitChanges.vue?vue&type=script&lang=js"
export * from "./SubmitChanges.vue?vue&type=script&lang=js"

import "./SubmitChanges.vue?vue&type=style&index=0&id=ba1a212a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba1a212a"]])

export default __exports__